import * as moment from "moment";
import { BIG_LOGO } from "./contantsTemplate";
moment.locale('es');

export const pdfReporteEstadoActualTemplate = async (revenueSummary: any): Promise<any> => {
  // Encabezados
  const byContainerTypeHeaders = [
    { text: 'Tipo', style: 'headerTableData' },
    { text: 'Cantidad', style: 'headerTableData' },
    { text: 'Promedio días estadía', style: 'headerTableData' },
    { text: 'Ingreso potencial', style: 'headerTableData' }
  ];

  const pendingContainersHeaders = [
    { text: 'Contenedor', style: 'headerTableData' },
    { text: 'Tipo', style: 'headerTableData' },
    { text: 'Conductor', style: 'headerTableData' },
    { text: 'Días estadía', style: 'headerTableData' },
    { text: 'Fecha ingreso', style: 'headerTableData' },
    { text: 'Ingreso potencial', style: 'headerTableData' }
  ];

  const overdueContainersHeaders = [
    { text: 'Contenedor', style: 'headerTableData' },
    { text: 'Tipo', style: 'headerTableData' },
    { text: 'Conductor', style: 'headerTableData' },
    { text: 'Días estadía', style: 'headerTableData' },
    { text: 'Ingreso potencial', style: 'headerTableData' }
  ];

  // Filas
  const byContainerTypeRows = [
    byContainerTypeHeaders,
    ...revenueSummary.byContainerType.map(type => [
      { text: type.typeName },
      { text: type.count },
      { text: type.averageStayDays },
      { text: `$${Number(type.potentialRevenue).toLocaleString('es-CO')}` }
    ])
  ];

  const pendingContainersRows = [
    pendingContainersHeaders,
    ...revenueSummary.pendingContainers.map(item => [
      { text: item.container },
      { text: item.containerType?.name || '' },
      { text: item.driverName },
      { text: item.currentStayDays },
      { text: item.date ? moment(item.date).format('YYYY-MM-DD HH:mm') : '' },
      { text: `$${Number(item.potentialAmount).toLocaleString('es-CO')}` }
    ])
  ];

  const overdueContainersRows = [
    overdueContainersHeaders,
    ...revenueSummary.overdueContainers.map(item => [
      { text: item.container },
      { text: item.containerType },
      { text: item.driverName },
      { text: item.currentStayDays },
      { text: `$${Number(item.potentialAmount).toLocaleString('es-CO')}` }
    ])
  ];

  // Resumen general
  const summaryRows = [
    [
      { text: 'Contenedores en sitio', style: 'headerTableStatistical' },
      { text: revenueSummary.currentStatus.totalContainersInSite, alignment: 'center' }
    ],
    [
      { text: 'Ingreso potencial', style: 'headerTableStatistical' },
      { text: `$${Number(revenueSummary.currentStatus.totalPotentialRevenue).toLocaleString('es-CO')}`, alignment: 'center' }
    ],
    [
      { text: 'Contenedores con más de 7 días', style: 'headerTableStatistical' },
      { text: revenueSummary.currentStatus.overdueContainers, alignment: 'center' }
    ],
    [
      { text: 'Promedio días estadía', style: 'headerTableStatistical' },
      { text: revenueSummary.currentStatus.averageStayDays, alignment: 'center' }
    ]
  ];

  // Alertas
  const alerts = [];
  if (revenueSummary.currentStatus.alerts.hasOverdueContainers) alerts.push('Hay contenedores con más de 7 días.');
  if (revenueSummary.currentStatus.alerts.highOccupancy) alerts.push('Alta ocupación.');
  if (revenueSummary.currentStatus.alerts.lowActivity) alerts.push('Baja actividad.');

  return {
    footer: function (currentPage, pageCount) {
      return {
        columns: [
          { text: 'DIRECCIÓN: VIA ALTERNA KM-7 CALLE 15A # 47 BIS - 11 - BUENAVENTURA', style: 'footer' },
          { text: 'PÁGINA ' + currentPage.toString() + ' DE ' + pageCount, alignment: 'right', style: 'footer' }
        ], margin: [20, 3, 20, 0]
      }
    },
    pageSize: 'legal',
    pageMargins: [20, 20, 20, 25],
    pageOrientation: 'landscape',
    content: [
      {
        image: BIG_LOGO,
        alignment: 'center'
      },
      {
        text: '"PIKI7 SAS"', fontSize: 12, bold: true, alignment: 'center'
      },
      {
        text: 'NIT. 900.368.831-9', fontSize: 10, alignment: 'center'
      },
      {
        text: 'Reporte de Estado Actual de Contenedores',
        alignment: 'center',
        fontSize: 14,
        bold: true,
        margin: [0, 18, 0, 18]
      },
      {
        text: `Generado: ${moment(revenueSummary.generatedAt).format('YYYY-MM-DD HH:mm')}`,
        alignment: 'right',
        fontSize: 10,
        margin: [0, 0, 0, 10]
      },
      alerts.length > 0 ? {
        text: `Alertas: ${alerts.join(' ')}`,
        color: 'red',
        fontSize: 11,
        bold: true,
        margin: [0, 0, 0, 10]
      } : {},
      // Resumen por tipo de contenedor
      {
        text: 'Resumen por tipo de contenedor',
        alignment: 'left',
        fontSize: 12,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      {
        style: 'tableContent',
        table: {
          widths: ['*', 'auto', 'auto', 'auto'],
          body: byContainerTypeRows
        },
        margin: [0, 0, 0, 20]
      },
      // Detalle de contenedores pendientes
      {
        text: 'Detalle de contenedores pendientes',
        alignment: 'left',
        fontSize: 12,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      {
        style: 'tableContent',
        table: {
          widths: ['*', 'auto', '*', 'auto', 'auto', 'auto'],
          body: pendingContainersRows
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return (rowIndex % 2 === 0) ? '#EEEEEE' : null;
          }
        },
        margin: [0, 0, 0, 20]
      },
      {
        text: 'Detalle de contenedores con mas de 7 días',
        alignment: 'left',
        fontSize: 12,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      {
        style: 'tableContent',
        table: {
          widths: ['*', 'auto', '*', 'auto', 'auto'],
          body: overdueContainersRows
        },
        layout: {
          fillColor: function (rowIndex, node, columnIndex) {
            return (rowIndex % 2 === 0) ? '#EEEEEE' : null;
          }
        },
        margin: [0, 0, 0, 20]
      },
      // Resumen general
      {
        text: 'Resumen general',
        alignment: 'left',
        fontSize: 12,
        bold: true,
        margin: [0, 10, 0, 5]
      },
      {
        style: 'tableContent',
        table: {
          widths: ['*', 'auto'],
          body: summaryRows
        },
        margin: [0, 0, 0, 20]
      },
    ],
    styles: {
      headerTableData: {
        bold: true,
        fillColor: '#95A5A6'
      },
      headerTableStatistical: {
        alignment: 'center',
        bold: true,
        fillColor: '#95A5A6',
        margin: [10, 0]
      },
      footer: {
        opacity: 0.4,
        fontSize: 11,
      },
      tableFilter: {
        bold: true,
      },
      tableContent: {
        fontSize: 10
      }
    }
  }
}
